import { Avatar, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/system';
import Menu from 'Components/Header/Menu';
import { openMenu } from 'ducks/ui';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getInitials from 'utils/getInitials';

const SectionDesktop = styled('div')({
    display: 'flex'
});

const AvatarStyled = styled(Avatar)(() => ({
    height: 44,
    width: 44
}));

// shouldForwardProp, don’t forward `showMenu` to the DOM, or else you will get an error in the rendering div
// Alternative:
// const AvatarText = styled(({ showMenu, ...other }) => <Avatar {...other} />)(
//     ({ theme, showMenu }) => ({
//         /* same styles as above */
//     })
// );
const AvatarText = styled(Avatar, { shouldForwardProp: prop => prop !== 'showMenu' })(({ theme, showMenu }) => ({
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.white,
    cursor: 'pointer',
    height: 44,
    width: 44,
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.light, 0.65),
        color: alpha(theme.palette.primary.white, 0.65)
    },
    ...(showMenu && {
        backgroundColor: alpha(theme.palette.primary.light, 0.65),
        color: alpha(theme.palette.primary.white, 0.65)
    })
}));

const Component = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const showMenu = useSelector(state => state.ui.showMenu);
    const currentUser = useSelector(state => state.users.models[state.auth.currentUserId]) || {};
    const dispatch = useDispatch();

    const displayMenu = event => {
        setAnchorEl(event.currentTarget);
        dispatch(openMenu());
    };

    return (
        <SectionDesktop>
            <IconButton onClick={displayMenu} onMouseEnter={displayMenu}>
                <AvatarStyled>
                    <AvatarText showMenu={showMenu}>{getInitials(currentUser.name)}</AvatarText>
                </AvatarStyled>
            </IconButton>
            <Menu anchorEl={anchorEl}/>
        </SectionDesktop>
    );
};

export default Component;
